if (!customElements.get('le-seven-reviews-carousel')) {
  customElements.define(
    'le-seven-reviews-carousel',
    class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced === 'true') return;

        this.groups = Array.from(this.querySelectorAll('.le-seven-reviews__group'));
        if (this.groups.length < 3) {
          window.requestAnimationFrame(() => this.connectedCallback());
          return;
        }

        this.dataset.enhanced = 'true';
        this.classList.add('is-enhanced');

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.isInteracting = false;
        this.resumeTimer = null;
        this.lastFrameTime = null;
        this.cycleDurationSeconds = 72;
        this.autoScrollPosition = 0;

        this.setInitialPosition = () => {
          this.groupWidth = this.groups[0].getBoundingClientRect().width;
          if (!this.groupWidth) return;
          this.autoScrollPosition = this.groupWidth;
          this.scrollLeft = this.autoScrollPosition;
        };

        this.normalizePosition = () => {
          if (!this.groupWidth) return;
          if (this.scrollLeft >= this.groupWidth * 2) {
            this.scrollLeft -= this.groupWidth;
          } else if (this.scrollLeft <= 0) {
            this.scrollLeft += this.groupWidth;
          }
          this.autoScrollPosition = this.scrollLeft;
        };

        this.autoScroll = (time) => {
          if (this.lastFrameTime === null) this.lastFrameTime = time;
          const elapsed = Math.min(time - this.lastFrameTime, 64);
          this.lastFrameTime = time;

          if (!this.isInteracting && !this.reducedMotion.matches && this.groupWidth) {
            const pixelsPerSecond = this.groupWidth / this.cycleDurationSeconds;
            this.autoScrollPosition += (pixelsPerSecond * elapsed) / 1000;
            if (this.autoScrollPosition >= this.groupWidth * 2) {
              this.autoScrollPosition -= this.groupWidth;
            }
            this.scrollLeft = this.autoScrollPosition;
          }

          this.animationFrame = window.requestAnimationFrame(this.autoScroll);
        };

        this.pauseForInteraction = () => {
          window.clearTimeout(this.resumeTimer);
          this.isInteracting = true;
          this.classList.add('is-dragging');
        };

        this.resumeAfterInteraction = () => {
          this.classList.remove('is-dragging');
          this.normalizePosition();
          window.clearTimeout(this.resumeTimer);
          this.resumeTimer = window.setTimeout(() => {
            this.isInteracting = false;
            this.lastFrameTime = null;
          }, 4000);
        };

        this.handleScroll = () => {
          if (this.isInteracting) this.normalizePosition();
        };

        this.addEventListener('pointerdown', this.pauseForInteraction, { passive: true });
        this.addEventListener('pointerup', this.resumeAfterInteraction, { passive: true });
        this.addEventListener('pointercancel', this.resumeAfterInteraction, { passive: true });
        this.addEventListener('scroll', this.handleScroll, { passive: true });
        this.addEventListener('mouseenter', this.pauseForInteraction);
        this.addEventListener('mouseleave', this.resumeAfterInteraction);
        this.addEventListener('focusin', this.pauseForInteraction);
        this.addEventListener('focusout', this.resumeAfterInteraction);

        this.resizeObserver = new ResizeObserver(() => {
          const previousWidth = this.groupWidth;
          this.groupWidth = this.groups[0].getBoundingClientRect().width;
          if (!previousWidth && this.groupWidth) {
            this.autoScrollPosition = this.groupWidth;
            this.scrollLeft = this.autoScrollPosition;
          }
        });
        this.resizeObserver.observe(this);

        this.setInitialPosition();
        this.animationFrame = window.requestAnimationFrame(this.autoScroll);
      }

      disconnectedCallback() {
        window.cancelAnimationFrame(this.animationFrame);
        window.clearTimeout(this.resumeTimer);
        this.resizeObserver?.disconnect();
      }
    }
  );
}
